import Link from 'next/link';

const SubMenu = ({ routes, onLinkClick }) => {
  const handleClick = (e) => {
    e.currentTarget.blur();
    if (onLinkClick) {
      onLinkClick();
    }
  };

  return (
    <div className="flex flex-col gap-y-6 lg:gap-y-4">
      {routes.map((sublink) => (
        <Link
          key={sublink.label}
          href={sublink.href}
          className="cursor-pointer lg:hover:scale-105"
          onClick={handleClick}
        >
          {sublink.label}
        </Link>
      ))}
    </div>
  );
};

export default SubMenu;
